import React from 'react'
import { detectVideoPlatform, getVideoEmbedProps } from 'utils/videoUtils'

export default function VideoOrImage({ videoUrl, imageUrl, alt }) {
  if (videoUrl) {
    const videoInfo = detectVideoPlatform(videoUrl)
    const embedProps = videoInfo ? getVideoEmbedProps(videoInfo) : null
    if (embedProps) {
      return (
        <div className="w-full" style={{ aspectRatio: '16/9' }}>
          <iframe
            {...embedProps}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          />
        </div>
      )
    }
  }

  if (imageUrl) {
    return <img src={imageUrl} alt={alt} className="w-full max-h-56 object-cover" />
  }

  return null
}
